const KEYS_MAP = {
  other: 'other',
  loggingIn: 'logging-in',
};

const other = {
  id: KEYS_MAP.other,
  label: 'Other',
  value: 'Other',
};

const issueTypes = [
  {
    id: KEYS_MAP.loggingIn,
    label: 'Logging in',
    value: 'Logging in',
  },
  {
    id: 'passwords',
    label: 'Passwords',
    value: 'Passwords',
  },
  {
    id: 'assignment',
    label: 'Assignment',
    value: 'Assignment',
  },
  {
    id: 'printing',
    label: 'Printing',
    value: 'Printing',
  },
  {
    id: 'results',
    label: 'Results',
    value: 'Results',
  },
  other,
];

const schoolOrInstitutional = [
  {
    id: 'yes',
    label: 'Yes',
    value: true,
  },
  {
    id: 'no',
    label: 'No',
    value: false,
  },
];

const schoolOrInstitutionalEnabledIssueTypes = [KEYS_MAP.loggingIn, other.id];

export {
  issueTypes,
  schoolOrInstitutional,
  schoolOrInstitutionalEnabledIssueTypes,
};
